exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price .p[data-v-a56bfee2]{font-family:NUM;font-size:20px;font-weight:500}.price .btn[data-v-a56bfee2]{background:#1890ff;color:#fff;cursor:pointer;font-size:12px;padding:4px 8px;border-radius:4px;margin-left:10px;position:relative;bottom:1px}\n", ""]);

// exports
